import 'jquery';
import 'bootstrap';

import {
	toggleLanguageSelector,
	toggleRegionSelector,
} from '../frontoffice/js/page.js';
// Styling
import '../frontoffice/css/style.less';

import initializeBaseApp from './base-app';

window.toggleLanguageSelector = toggleLanguageSelector;
window.toggleRegionSelector = toggleRegionSelector;

initializeBaseApp();
